import {
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  Tooltip,
  useDisclosure,
} from "@nextui-org/react";
import React, { useState } from "react";
import { FieldList } from "../../utils/constant";
import EditFormulaModal from "./EditFormulaModal";
import ConfirmDeleteModal from "../../components/ConfirmDeleteModal";

const FormulaInfoTable = ({ fieldInfoList, setFieldInfoList }) => {
  const [editItem, setEditItem] = useState({});
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onOpenChange: onDeleteOpenChange,
  } = useDisclosure();
  const [itemToDelete, setItemToDelete] = useState(null);

  const headers = ["Formula Name", ""];

  const updateFieldHandler = (item) => {
    const newFieldInfoList = fieldInfoList.map((data) => {
      if (data.id === item.id) {
        return item;
      } else return data;
    });
    setFieldInfoList(newFieldInfoList);
  };


  const confirmDeleteHandler = (item) => {
    setItemToDelete(item);
    onDeleteOpen();
  };

  const deleteHandler = () => {
    if (itemToDelete) {
      const newFieldInfoList = fieldInfoList.filter((item) => item.id !== itemToDelete.id);
      setFieldInfoList(newFieldInfoList);
      setItemToDelete(null);
    }
  };

  return (
    <>
      {fieldInfoList.length > 0 && (
        <div className="m-4">
          <Table removeWrapper aria-label="Formulas table">
            <TableHeader>
              {headers.map((header, headerIndex) => (
                <TableColumn key={headerIndex}>{header}</TableColumn>
              ))}
            </TableHeader>
            <TableBody>
              {fieldInfoList &&
                fieldInfoList.map((item) => {
                  return (
                    <TableRow key={item.id}>
                      <TableCell className="flex items-center gap-2">
                        <span>
                          {item.title}{" "}
                          {item.Required && (
                            <span style={{ color: "#f31b66" }}> *</span>
                          )}
                        </span>
                      </TableCell>

                      <TableCell>
                        <div className="flex items-center justify-end gap-4">
                          <div
                            className="cursor-pointer flex items-center justify-center"
                            onClick={() => {
                              setEditItem(item);
                              onOpen();
                            }}
                          >
                            <Tooltip size="sm" content="Edit field">
                              <lord-icon
                                src="https://cdn.lordicon.com/lzgmgrnn.json"
                                trigger="hover"
                                
                                style={{ width: "20px", height: "20px" }}
                              ></lord-icon>
                            </Tooltip>
                          </div>
                          <div
                            className="flex gap-4 text-center justify-end cursor-pointer"
                            onClick={() => confirmDeleteHandler(item)}
                          >
                            <Tooltip size="sm" content="Delete field">
                              <lord-icon
                                src="https://cdn.lordicon.com/wpyrrmcq.json"
                                trigger="hover"
                                
                                style={{ width: "20px", height: "20px" }}
                              ></lord-icon>
                            </Tooltip>
                          </div>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
      )}
      {isOpen && (
          <EditFormulaModal
            onSubmitHandler={updateFieldHandler}
            isOpen={isOpen}
            onOpen={onOpen}
            onOpenChange={onOpenChange}
            fieldType={1}
            id={editItem.id}
            item={editItem}
          />
        )}
      <ConfirmDeleteModal
        isOpen={isDeleteOpen}
        onOpenChange={onDeleteOpenChange}
        onConfirm={deleteHandler}
        title="Delete Formula"
        message="Are you sure you want to delete this formula?"
        itemName={itemToDelete?.title}
      />
    </>
  );
};

export default FormulaInfoTable;
